import type EditorViewState from '../store/schema/EditorViewState';
import { callEditorApi } from './callEditorApi';
import { QueryScope } from 'roosterjs-editor-types';

export interface ImageHolder {
    image: HTMLImageElement | null;
}

/**
 * Get selected image
 * @param viewState The editor viewstate
 * @param includeEditorSelection When pass true, if there is no selected image from viewState, try to get selected image from editor
 */
export default function getSelectedImage(
    viewState: EditorViewState,
    includeEditorSelection?: boolean
) {
    let result = viewState.isImageSelected ? getImageHolder(viewState)?.image : null;

    // If the cached image is no longer available in editor, ignore it
    if (result && !callEditorApi(viewState, 'contains', result as any)) {
        result = null;
    }

    if (!result && includeEditorSelection) {
        const images = callEditorApi(viewState, 'queryElements', 'img', QueryScope.OnSelection);
        result = images?.[0] as HTMLImageElement;
    }

    return result;
}

export function getImageHolder(viewState: EditorViewState): ImageHolder | undefined {
    return callEditorApi(
        viewState,
        'getCustomData',
        'SelectedImageHolder',
        (): ImageHolder => ({
            image: null,
        })
    ) as ImageHolder | undefined;
}
